import briefcase from 'src/assets/briefcase_blue.svg';
import shoppingCart from 'src/assets/shopping_cart_blue.svg';
import document from 'src/assets/document_blue.svg';
import globe from 'src/assets/globe_blue.svg';
import gift from 'src/assets/gift_blue.svg';
import headphone from 'src/assets/headphone_blue.svg';
const data = [
  {
    id: 1,
    name: 'Sản phẩm bảo hiểm',
    icon: briefcase,
  },
  {
    id: 2,
    name: 'Mua bảo hiểm',
    icon: shoppingCart,
  },
  {
    id: 3,
    name: 'Thông tin hợp đồng',
    icon: document,
  },
  {
    id: 4,
    name: 'Đóng phí trực tuyến',
    icon: globe,
  },
  {
    id: 5,
    name: 'Tin tức khuyến mãi',
    icon: gift,
  },
  {
    id: 6,
    name: 'Đăng ký tư vấn',
    icon: headphone,
  },
];
export default data;
